import { formatDate, formatCnpj } from '@btime/helpers'
import moment from 'moment'

export const getReplyValue = reply => {
  if (!reply) {
    return ''
  }
  if (reply.question.type.name === 'sign') {
    return reply.value.name
  }
  return reply.value
}

export const formatCNPJ = cnpj => {
  return formatCnpj(cnpj.toString())
}

export const findReplyByQuestionId = (replies, questionId) => {
  return replies.find(reply => reply.question.id === questionId)
}

export const findReplyByFieldId = (replies, fieldId) => {
  return replies.find(reply => reply.field.id === fieldId)
}

export const filterReplyByQuestionId = (replies, questionId) => {
  return replies.filter(reply => reply.question.id === questionId)
}

export const toDateFormat = (date, format) => {
  if (!date) {
    return 'Não informada'
  }
  // if (typeof date === 'string') {
  //   return formatDate(format, new Date(date))
  // }
  return formatDate(format, date)
}

export const toCurrency = value => {
  const invalid_values = ['N/A', '', NaN]
  if (invalid_values.includes(Number(value))) {
    return
  }
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  })

  return formatter.format(value)
}

export const getFieldValue = (fieldValues, fieldName) => {
  return fieldValues.find(fv => {
    return fv.field.name === fieldName
  })
}

export const filterRepliesByParentReference = (replies, reference) => {
  return replies.filter(
    reply => reply.question.parentReference && reply.question.parentReference.indexOf(reference) === 0
  )
}

export const getRepliesFromBlockQuestion = (replies, blockIndex) => {
  return replies.filter(reply => reply.blockIndex === blockIndex)
}

export const getComplement = complement => {
  const result = complement ? `- ${complement}` : ''
  return result
}
